import { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { WebAppLink } from '../WebAppCta';

const navItems = [
    { label: 'امکانات', href: '#features' },
    { label: 'نحوه کار', href: '#how-it-works' },
    { label: 'ویرایش هوشمند', href: '#smart-edit' },
    { label: 'سوالات', href: '#faq' },
];

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false);
    const location = useLocation();

    const homeHref = (anchor) => location.pathname === '/' ? anchor : `/${anchor}`;

    return (
        <header className="site-header">
            <nav className="site-container nav-shell" aria-label="ناوبری اصلی">
                <Link to="/" className="brand-link" aria-label="هوش‌پز، صفحه اصلی">
                    <img src="/hooshpaz-logo.webp" alt="" className="brand-logo" />
                    <span>
                        <strong>هوش‌پز</strong>
                        <small>عشقِ غذا، با چاشنی هوش</small>
                    </span>
                </Link>

                <div className="nav-links" aria-label="بخش‌های صفحه">
                    {navItems.map((item) => (
                        <a key={item.href} href={homeHref(item.href)}>{item.label}</a>
                    ))}
                    <NavLink to="/recipes" className="nav-cookbook">کتاب آشپزی</NavLink>
                </div>

                <div className="nav-actions">
                    <WebAppLink link="navbar" className="nav-webapp">نسخه وب هوش‌پز</WebAppLink>
                    <a className="button button-small nav-cta" href={homeHref('#download')}>
                        دریافت اپلیکیشن
                    </a>
                </div>

                <button
                    type="button"
                    className="mobile-menu-button"
                    onClick={() => setIsOpen((open) => !open)}
                    aria-expanded={isOpen}
                    aria-controls="mobile-navigation"
                    aria-label={isOpen ? 'بستن منو' : 'باز کردن منو'}
                >
                    {isOpen ? <X size={24} /> : <Menu size={24} />}
                </button>
            </nav>

            {isOpen && (
                <div id="mobile-navigation" className="mobile-navigation">
                    {navItems.map((item) => (
                        <a key={item.href} href={homeHref(item.href)} onClick={() => setIsOpen(false)}>
                            {item.label}
                        </a>
                    ))}
                    <Link to="/recipes" onClick={() => setIsOpen(false)}>کتاب آشپزی</Link>
                    <a href={homeHref('#download')} onClick={() => setIsOpen(false)}>دریافت اپلیکیشن</a>
                    <WebAppLink link="mobile_menu" className="mobile-navigation-webapp">نسخه وب هوش‌پز (بدون نصب)</WebAppLink>
                </div>
            )}
        </header>
    );
};

export default Navbar;
